import PropTypes from "prop-types"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import Confirmation from "components/ui/confirmation"
import { IS_JEWLR, isTestMode } from "helpers/application"
import withGeo from "hoc/with-geo"
import getJewlrCountries from "site-data/jewlr/countries"
import getPortalCountries from "site-data/portal/countries"

const LocaleDialog = ({
  currentCountry,
  geoCookie,
  geoCookieDefault,
  selectedGeoCookie,
  setSelectedGeo,
  showCountryModal,
  toggleCountryModal,
}) => {
  const location = useLocation()
  const allCountries = IS_JEWLR() ? getJewlrCountries() : getPortalCountries()

  const path = `${location.pathname === "/" ? "" : location.pathname}`
  let params = `${location.search ? `${location.search}&` : "?"}`
  if (typeof URLSearchParams !== "undefined") {
    params = new URLSearchParams(location.search)
    params.delete("geo")
    params.delete("locale")
    params = `${params.toString() ? `?${params.toString()}&` : "?"}`
  }

  const availableGeos = allCountries.map((c) => c.geo)
  const country = allCountries.find((c) => c.geo == geoCookie)

  if (!country || !currentCountry) {
    return ""
  }

  useEffect(() => {
    toggleCountryModal(
      geoCookieDefault &&
        geoCookie !== currentCountry.geo &&
        (!selectedGeoCookie || selectedGeoCookie !== currentCountry.geo) &&
        availableGeos.includes(geoCookie)
    )
  }, [geoCookie, selectedGeoCookie])

  const subdomain =
    sl.config.env === "production" ? (IS_JEWLR() ? "www" : "") : sl.config.env
  const separator = IS_JEWLR() ? "." : ""
  const domain =
    sl.config.env === "development"
      ? `${sl.config.site_url}`
      : `${subdomain}${separator}${country.url}`

  return (
    <Confirmation
      cancelText={`Keep shopping in ${currentCountry.dialog_title}`}
      confirmText={`Start shopping in ${country.dialog_title}`}
      onCancel={() => {
        setSelectedGeo(currentCountry.geo)
        toggleCountryModal(false)
      }}
      onConfirm={() => {
        if (!isTestMode) {
          dataLayer.push({ event: "change-country-locale-dialog" })
        }
        const url = `https://${domain}${path}${params}&geo=${country.geo}`
        window.location.href = url
      }}
      show={showCountryModal}
      title={
        <>
          It looks like you&apos;re <br />
          in {country.dialog_title}!
        </>
      }
    />
  )
}

LocaleDialog.propTypes = {
  currentCountry: PropTypes.object,
  geoCookie: PropTypes.string,
  geoCookieDefault: PropTypes.string,
  selectedGeoCookie: PropTypes.string,
  setSelectedGeo: PropTypes.func,
  showCountryModal: PropTypes.bool,
  toggleCountryModal: PropTypes.func,
}

export default withGeo(LocaleDialog)
